import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { environment } from 'src/environments/environment';
import { httpOptions } from "./headers";

@Injectable({
  providedIn: 'root'
})
export class ApiProjectTypeService {

  private projectTypeUrl = environment.projectTypeUrl;
  private httpOptions = {
    headers: new HttpHeaders({
      'Content-Type':  'application/json',
      'Authorization': 'Basic ' + btoa('estimator:!Estimator')
    })
  };

  constructor(private http: HttpClient) { }

  getProjectTypes(): Observable<any> {
    return this.http.get<any>(this.projectTypeUrl,httpOptions);
  }

  addProjectType(obj: any): Observable<any> {
    
    
    return this.http.post<any>(this.projectTypeUrl, obj,httpOptions);
  }

  
}
